import React from 'react';
import axios, { AxiosRequestConfig } from 'axios';
import { Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { Constants } from "../../constants";
import 'bootstrap/dist/css/bootstrap.min.css';

class PaymentConfirmation extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            loading: true,
            isError: false,
            label:''
        };
    }

    componentDidMount() {

        let params = new URLSearchParams(window.location.search);
        let foo = params.get('TrxKey');
        let result = params.get('ResultStatus');
        let paymentUpdateResult = params.get('result');
        let walletId = params.get('id');

        if (result == null && (paymentUpdateResult == 'true' || walletId != null)) {
            this.setState({
                label: 'Payment information updated successfully. Please refresh page for new cards/accounts to appear in the dropdown above.',
                loading: false
            });
        } else if (result == 'True') {
            axios.get(`${Constants.apiURL}/api/Payment/confirm`, {
                params: {
                    trxKey: foo
                }
            }).then(response => {
                if (response.data == 2) {
                    this.setState({
                        label: 'Thank you for your payment. A receipt has been delivered to the email address provided. Please note that this transaction will be reflected as a “Boland” payment on your account statement.',
                        loading: false
                    });
                }
                else {
                    this.setState({
                        label: 'Thank you for your payment. A receipt has been delivered to the email address provided.',
                        loading: false
                    });
                }
            }).catch((response) => {
                this.setState({
                    label: 'There was an error processing your payment.',
                    isError: true,
                    loading: false
                });
            });
        }
        else {
            this.setState({
                label: 'There was an error processing your payment.',
                isError: true,
                loading: false
            });
        }
    }


    render() {
        const success = {
            fontSize: 18, color: '#00973A', fontWeight: 'bold', paddingLeft: 10
        }

        const error = {
            fontSize: 18, color: '#FF0000', fontWeight: 'bold', paddingLeft: 10
        }

        return (
            <div>
                <div style={{ textAlign: 'center', marginTop: '20px' }} hidden={!this.state.loading}>
                    <Spinner
                        style={{ verticalAlign: 'center', width: "3rem", height: "3rem" }}
                        animation="border"
                        role="status"
                        aria-hidden="true"
                    />
                </div>
                <p style={this.state.isError ? error : success}> {this.state.label} </p>
            </div>
        );
    }
}

export default withRouter(PaymentConfirmation);